import {onFind, initInScope} from "@elements/init-modules-in-scope";
import {on, find, findAllIn, closest} from "@elements/dom-utils";
import axios from "axios";
import {translate} from '@elements/translations';

export function init() {
    onFind('.js-planner__pdf-loader', function (pdfLoader) {
        let id = pdfLoader.getAttribute('data-id');
        let tries = 0;

        let interval = setInterval(function(){
            axios({
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                url: '/r/terraceplanner/pdf/pdf-finished?id=' + id,
                responseType: 'json'
            }).then(({data}) => {
                if(data.ok) {
                    location.href = '/r/terraceplanner/pdf/display/' + translate('terrassenplan.pdf') + '?id='  + id;

                    clearInterval(interval);
                } else {
                    tries++;
                    if(tries > 150) {
                        location.reload();
                    }
                }
            });
        }, 1000);
    });
}